// @flow

import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";

import useTranslatedFieldNames from "src/hooks/useTranslatedFieldNames";

import { AddButton } from "./styles";

type Props = {
  type?: string,
  isSelect?: boolean,
  disabled: boolean,
  handleClick: Function,
  isMandatory?: boolean,
};

const AddData = ({
  type = "",
  handleClick,
  isSelect = false,
  disabled,
  isMandatory,
}: Props) => {
  const fieldNames = useTranslatedFieldNames();

  if (isSelect)
    return (
      <AddButton
        data-cy={`checklist-add-button-select-${type}`}
        onClick={handleClick}
        disabled={disabled}
        isMandatory={isMandatory}
      >
        {i18n.t(k.SELECT)}
      </AddButton>
    );

  return (
    <AddButton
      data-cy={`checklist-add-button-${type}`}
      onClick={handleClick}
      disabled={disabled}
      isMandatory={isMandatory}
    >
      {isSelect
        ? i18n.t(k.SELECT)
        : `${i18n.t(k.U_B_ADD)} ${fieldNames[type] || ""}`}
    </AddButton>
  );
};

export default AddData;
